import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Icon, useToast } from '@unite-us/app-components';
import './ClientProfileLink.scss';

const ClientProfileLink = ({
  children,
  linkToCopy = null,
  successMessage = 'Link has been copied to clipboard.',
  iconSize = 16,
}) => {
  const { addToast } = useToast();
  const handleCopy = () => {
    const textToCopy = linkToCopy || window.location.href;

    navigator.clipboard.writeText(textToCopy)
      .then(() => addToast({
        message: successMessage,
        type: 'success',
      }))
      .catch(() => addToast({
        message: 'Failed to copy to clipboard.',
        type: 'error',
      }));
  };

  const iconTrigger = (
    <Popover
      content={<span>Copy link</span>}
      position="bottom"
      trigger="hover"
      width={16}
      className="inline-block py-1 px-0 text-center"
    >
      <Icon
        icon="Link"
        size={iconSize}
        color="action-blue"
        onClick={handleCopy}
        aria-label="Copy link"
        className="cursor-pointer"
      />
    </Popover>
  );

  return (
    <Popover
      id="popover-client-profile-link"
      content={iconTrigger}
      position="right"
      trigger="hover"
      className="inline-block py-1 px-0 text-center bg-transparent border-none"
    >
      {children}
    </Popover>
  );
};

ClientProfileLink.propTypes = {
  children: PropTypes.node.isRequired,
  linkToCopy: PropTypes.string,
  successMessage: PropTypes.string,
  iconSize: PropTypes.number,
};

ClientProfileLink.defaultProps = {
  linkToCopy: null,
  successMessage: 'Link has been copied to clipboard.',
  iconSize: 16,
};

export default ClientProfileLink;
